import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from "@tanstack/react-router";
/**
 * The default `EntityLink`/`ProcessLink` of the renderer seam.
 *
 * Both stay SLOTS on `ChatRendererDataAdapter` — a host with different routes
 * passes its own — but every host that mounts inside this product's shell has
 * the same ones, and an adapter that quietly diverged would send a chip to a
 * page that does not exist.
 */ /** Every entity route the transcript can link to, except the kind-fixed ones. */ export function chatEntityRoute(type, id, slug) {
    switch(type){
        case "user":
            return `/${slug}/org-members/${id}`;
        case "process":
            return `/${slug}/processes/all-processes/${id}`;
        case "system":
            return `/${slug}/systems/${id}`;
        case "department":
            return `/${slug}/departments/${id}`;
        case "artifact":
            return `/${slug}/artifacts/${id}`;
        case "externalContact":
            return `/${slug}/external-contacts/${id}`;
        default:
            return "#";
    }
}
/** The OrgFunction catalog is one collection on two kind-fixed pages (ADR 0004). */ function orgFunctionDetailRoute(kind) {
    return kind === "team" ? "/$slug/organization/teams/$orgFunctionId" : "/$slug/organization/functions/$orgFunctionId";
}
/**
 * The chip's anchor.
 *
 * `...rest` is spread onto the link ON PURPOSE: `HoverCardTrigger asChild`
 * merges its ref and its pointer/focus handlers onto this element, and React 19
 * delivers the ref as a plain prop — dropping either would leave the trigger
 * inert.
 */ export function ChatEntityLink({ type, id, slug, orgFunctionKind, children, ...rest }) {
    // Chat's `team` covers any OrgFunction, but the detail pages are kind-fixed
    // (/organization/teams vs …/functions), so this one route takes params.
    if (type === "team") {
        return /*#__PURE__*/ _jsx(Link, {
            to: orgFunctionDetailRoute(orgFunctionKind ?? "team"),
            params: {
                slug,
                orgFunctionId: id
            },
            ...rest,
            children: children
        });
    }
    return /*#__PURE__*/ _jsx(Link, {
        to: chatEntityRoute(type, id, slug),
        ...rest,
        children: children
    });
}
export function ChatProcessLink({ processId, slug, children, ...rest }) {
    return /*#__PURE__*/ _jsx(Link, {
        to: "/$slug/processes/all-processes/$processId",
        params: {
            slug,
            processId
        },
        ...rest,
        children: children
    });
}

//# sourceMappingURL=chat-entity-links.js.map